import React from 'react';
import { useTranslation } from 'react-i18next';

import offWhiteIcon from '@assets/multimediaIcons/offWhiteIcon.png';
import ColorButton from '@UI/ColorButton';
import ModalHeader from '@components/DeviceContainers/Multimedia/components/ModalHeader';
import Joystick from '@components/DeviceContainers/Multimedia/components/Joystick';
import Volume from '@components/DeviceContainers/Multimedia/components/Volume';
import OptionsButtons from '@components/DeviceContainers/Multimedia/components/OptionsButtons';

const styles = {
  mainContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  offButtonContainer: {
    display: 'flex',
    backgroundColor: 'rgba(70, 171, 213, 1)',
    borderRadius: 40,
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
  },
  tvSelectOffContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 50,
  },
  bottomContainer: {
    display: 'flex',
    flex: 1,
    paddingBottom: 30,
    gap: 30,
  },
  button: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '12px 0',
    backgroundColor: '#ECF7FB',
    borderRadius: '30px',
    maxWidth: '400px',
    height: 45,
  },
  buttonText: {
    fontWeight: '700',
    color: '#46ABD5',
    fontSize: 14,
  },
};

function MultimediaModalContainer(props) {
  const {
    setIsModalOpen, multimedia, func,
  } = props;
  const { t } = useTranslation();
  const onPressToAction = (pickedType) => {
    const pickedItem = multimedia[0].capabilities.find((item) => item.type.type_name === pickedType);
    if (pickedItem) {
      func(pickedItem.address, pickedItem.value);
    }
  };
  return (
    <div style={styles.mainContainer}>
      <ModalHeader setIsModalOpen={setIsModalOpen} />
      <div style={styles.tvSelectOffContainer}>
        <ColorButton
          onClick={() => onPressToAction('TV_on_off')}
          style={styles.offButtonContainer}
        >
          <img alt="offWhiteIcon" src={offWhiteIcon} style={{ height: 16, width: 16 }} />
        </ColorButton>
      </div>
      <Joystick onPressToAction={(type) => onPressToAction(type)} />
      <div style={styles.bottomContainer}>
        <Volume onPressToAction={(type) => onPressToAction(type)} />
        <OptionsButtons onPressToAction={(type) => onPressToAction(type)} />
      </div>
      <ColorButton onClick={() => setIsModalOpen(false)} style={styles.button}>
        {' '}
        <span style={styles.buttonText}>
          {t('close')}
        </span>
      </ColorButton>
    </div>
  );
}

export default MultimediaModalContainer;
